import { IRequestOptions } from '@beable/mwm-commons-endpoint-client';
import rosterBackendService from '../services/RosterBackendService';

const getFileConfig = (file: File): [formData: FormData, options?: IRequestOptions] => {
  const formData = new FormData();
  formData.append('file', file);
  const options= {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  };
  return [formData, options];
}

const uploadCreatioZipFile = (file: File) => {
  return rosterBackendService.uploadCreatioZipFile(...getFileConfig(file));
}

export default {
  uploadCreatioZipFile,
}